import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { message } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { useNavigate, Link } from 'react-router-dom';
import '../StyledComponents/Styles.css';
import imag from '../StyledComponents/img/logo (11).png';
import { validateUser } from "../handlers/adminApi";
import { axiosGet } from '../handlers/helpers';
import { DotLoader } from 'react-spinners'; // Importing DotLoader

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);  // State to manage loading state
    const navigate = useNavigate();
    const hasRun = useRef(false);

    const authCheck = async () => {
        setLoading(true); // Show loader while checking authentication
        var resp = await axiosGet(`${process.env.REACT_APP_API_HOSTNAME}/admin/verify-auth`);
        setLoading(false); // Hide loader after response is received
        if (resp != null) {
            if (resp.status === true) {
                navigate("/whooska/admin/dashboard", { state: { userData: resp.userData } });
            }
        }
    };

    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            authCheck();
        }
    }, []);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleSubmit = async () => {
        let formErrors = {};
        if (!email) {
            formErrors.email = "Email is required";
        }
        if (!password) {
            formErrors.password = "Password is required";
        }

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }
        setErrors({});

        setLoading(true); // Show loader during login process
        const userData = {
            email: email,
            password: password,
            role: "admin",
        };

        try {
            // Call the API to validate the user
            const response = await validateUser(userData);

            // Log the entire response for debugging purposes
            console.log("API Response:", response);
            console.log("Response Token:", response?.data?.token); // Logs token specifically

            setLoading(false); // Hide loader after response

            // Check the response for a successful status
            if (_.get(response, 'data.status', false)) {
                // If successful, store the token in localStorage
                localStorage.setItem("token", response.data.token);
                console.log("Token saved:", localStorage.getItem("token")); // Logs the token in localStorage
                navigate('/whooska/admin/dashboard');
            } else {
                // If not successful, show an error message
                message.error(_.get(response, 'data.message', 'An error occurred'));
            }
        } catch (error) {
            setLoading(false); // Hide loader if there's an error
            console.error("Error during login:", error);
            message.error('An error occurred while logging in');
        }
    };

    return (
        <div className="log-in-main">
            {loading ? (  // If loading is true, show the loader
                <div className="loader-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <DotLoader color="#F7812A" size={60} />
                </div>
            ) : (
                <div className="log-in-inner">
                    <div className="top">
                        <div className="top-inner">
                            <div className="logo">
                                <img src={imag} alt="" className="logo-w" />
                            </div>
                        </div>
                    </div>

                    <div className="form">
                        <form action="">
                            <div className="logos">
                                {/* <img src={imag} alt="" className="logo-w"/> */}
                            </div>
                            <h2>Admin</h2>
                            <p>Please enter your details to Sign In</p>

                            <>
                                <div className="form-group fullname">
                                    <label htmlFor="email">Email</label>
                                    <div className="password-container">
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder=""
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    {errors.email && <p className="error-text">{errors.email}</p>}
                                </div>

                                <div className="form-group fullname">
                                    <label htmlFor="password">Password</label>
                                    <div className="password-container">
                                        <input
                                            type={passwordVisible ? 'text' : 'password'}
                                            id="password"
                                            value={password}
                                            placeholder=""
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <FontAwesomeIcon
                                            icon={passwordVisible ? faEye : faEyeSlash}
                                            className="eye-icon"
                                            onClick={togglePasswordVisibility}
                                        />
                                    </div>
                                    {errors.password && <p className="error-text">{errors.password}</p>}
                                </div>

                                <div className="Password">
                                    <Link to="/whooska/admin/Forgot/Password">Forgot Password?</Link>
                                </div>
                                <div className="btn">
                                    <Link href="javascript:void(0)" onClick={() => handleSubmit()}>Log in</Link>
                                </div>
                            </>
                        </form>
                    </div>

                    <div className="bottom">
                        <div className="bottom-inner">
                            <div className="text-content">
                                <div className="copy">copyright @ WhooshkaTips</div>
                                <div className="text">
                                    This page is for 18+ only. Gamble Responsibly. Visit{" "}
                                    <span>www.gamblinghelponline.org.vic.au</span> or call <br />
                                    Gambling Help on <span>1800 858 858</span> The chances are you are about to lose
                                </div>
                                <div className="policy-container">
                                    <div className="policy">
                                        <Link to="/whooska/admin/Privacy/Policy">Privacy Policy</Link>
                                        <div className="separator"></div>
                                        <Link to="/whooska/admin/Terms/of/Service">Terms & Conditions</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoginPage;
